import React, {FC, useEffect} from "react";
import QuicktipLobby from "./QuicktipLobby";
import SmartbetLobby from "./SmartbetLobby";
import SuperbetLobby from "./SuperbetLobby";
import QuickbetLobby from "./QuickbetLobby";
import JackpotLobby from "./JackpotLobby";
import QuickbetXLobby from "./QuickbetXLobby";
import SidebarLobbyWidget from "../Components/Widget/SidebarLobbyWidget";
import {useLocation} from "react-router-dom";
import './Lobby.css'
import {trackEvent, trackTicketOpen} from "../../../../tracking/trackingService";
const lobbyComponents: Record<number, React.FC<any>> = {
    1: QuicktipLobby,
    2: SmartbetLobby,
    3: SuperbetLobby,
    4: QuickbetLobby,
    5: JackpotLobby,
    6: QuickbetXLobby,
};

const defaultOrder = [1, 2, 3, 4, 5, 6];
const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;
const Lobby: FC = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    // Bot auth params
    const botAccessToken  = params.get('access_token');
    const botRefreshToken = params.get('refresh_token');
    const viewType = params.get('view')
    const ticketOpenMode = params.get('ticketOpenMode')
    const defaultOpenType = params.get('defaultOpenType')
    const ticketTypes = params.get('tT')?.split(',')
        .map((type) => parseInt(type, 10))
        .filter((type) => !isNaN(type)) || [];

    const sourceParams = params.get('source');
    const authData = params.get('token');
    const atagVal = params.get('atag');
    const shouldRenderAll = ticketTypes.length === 0;
    const theme = params.get('theme') || 'lite';

    const ticketsToRender = ticketTypes.length
        ? ticketTypes
        : defaultOrder;

    if (authData) {
        localStorage.setItem('token', authData);
    } else {
        localStorage.removeItem('token');
    }

    useEffect(() => {
        if (viewType === 'fullPage') {
            const sendHeight = () => {
                const height = document.body.scrollHeight;

                window.parent.postMessage(
                    {
                        type: "SET_LOBBY_WIDGET_HEIGHT",
                        height
                    },
                    "*"
                );
            };

            sendHeight();
            const observer = new ResizeObserver(() => {
                sendHeight();
            });

            observer.observe(document.body);

            return () => {
                observer.disconnect();
            };
        }
    }, [viewType]);
    useEffect(() => {
        if (ticketOpenMode !== "modal") return;

        const handleClickCapture = (e: MouseEvent) => {
            const target = e.target as HTMLElement;
            const link = target.closest("a");
            if (!link) return;

            if (!link.classList.contains("js-ticket-link")) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            window.parent.postMessage(
                {
                    type: "OPEN_TICKET_MODAL",
                    url: (link as HTMLAnchorElement).href,
                    widgetId: 'lobbyModalID'
                },
                "*"
            );
        };
        document.addEventListener("click", handleClickCapture, true);

        return () => {
            document.removeEventListener("click", handleClickCapture, true);
        };
    }, [ticketOpenMode]);
    useEffect(()=>{
        trackEvent("ticket_open", {
            ticket_type: "lobby",
        })
        trackTicketOpen("Lobby");
    }, [])

    return (
        <>
            {
                viewType === 'sidebar'
                    ?
                    <SidebarLobbyWidget
                        defaultOpenType={defaultOpenType}
                        viewType={viewType}
                        types={ticketTypes}
                        atagParams={atagVal}
                        sourceParams={sourceParams}
                        ticketOpenMode={ticketOpenMode}
                        theme={theme}
                    />
                    :
                    <div className={`Lobby-container`} data-theme={theme ? theme : 'lite'}>
                        <main
                            className={viewType === 'fullPage' ? '' : "pt-2 pb-3"}
                            style={{
                                backgroundImage: viewType !== 'fullPage' ? `url(${toAbsoluteUrl('/assets/img/bg/lobby-bg.webp')})` : 'none',
                                backgroundSize: '100% 100%',
                                backgroundRepeat: 'no-repeat',
                                minHeight: '100vh',
                            }}
                        >
                            <div className={viewType === 'fullPage' ? 'container-fluid' : 'container'}>
                                <div className="row">
                                    {ticketsToRender.map((type) => {
                                        const Component = lobbyComponents[type];
                                        if (!Component) return null;

                                        return (
                                            <Component
                                                key={type}
                                                ticketOpenMode={ticketOpenMode}
                                                viewType={viewType}
                                                sourceParams={sourceParams}
                                                atagParams={atagVal}
                                                botAccessToken={botAccessToken}
                                                botRefreshToken={botRefreshToken}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                        </main>
                    </div>
            }
        </>

    );
};

export default Lobby;